import { Suspense } from 'react';
import { Route } from 'react-router-dom';
import { Loading } from '../components/common/Loading';
import { PrivateRoute } from './PrivateRoute';
import { RouteConfig } from './types';

export const createRoute = (config: RouteConfig) => {
  const element = config.isPrivate ? (
    <PrivateRoute>{config.element}</PrivateRoute>
  ) : (
    config.element
  );

  return (
    <Route
      key={config.path}
      path={config.path}
      element={<Suspense fallback={<Loading />}>{element}</Suspense>}
    />
  );
};

export const createRoutes = (configs: RouteConfig[]) => {
  return configs.map(createRoute);
};
